import React from 'react';
import cx from 'classnames';
import Text from '../../Text';
import '../styles/__tag-list-item.scss';






export default function TagListItem({
  tag: {
    color,
    label
  },
  className
}) {
  return (
    <div className={cx('tag-list-item', className || '')}>
      <Text>
        {label}
      </Text>
      <span className="tag-list-item__color" style={{ backgroundColor: color }} />
    </div>);

}